const DoDeleteBoard = async (board) => {
  const boardId = board._id
  return await new Promise((resolve, reject) => {
    const url = '/api/board/deleteOneBoard'
    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]
    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify({ boardId }),
    })
      .then((response) => {
        response.json().then((userRemoved) => {
          console.log('board ' + boardId + ' removed')
          resolve({ result: 'board deleted ', boardId: boardId })
        })
      })
      .catch((error) => {
        console.log('error deleting board ' + boardId, error)
        resolve({ result: 'error deleting board', boardId: boardId })
      })
  })
}
export default DoDeleteBoard
